/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-07-21 11:19:04
 * @LastEditTime: 2024-09-29 15:35:18
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Http from './api/http'
import animated from 'animate.css'
import fastClick from 'fastclick'
import 'babel-polyfill'
import './assets/style/reset.css'
import './assets/style/border.css'
import './assets/style/common.css'
import './assets/rem'
import Vant from 'vant'
import 'vant/lib/index.css'
import store from './store'
import VConsole from 'vconsole'
import env from './utils/env'

// 定义一个开关
const mock = false; // TODO:上线修改
if (process.env.NODE_ENV === 'development' && mock) {
  require('./mock/mock');
}

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(animated)
Vue.use(Vant)
if (env !== 'prod') {
  Vue.use(new VConsole())
}

// 把Http挂载到Vue实例上
Vue.prototype.$Http = Http
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js